import RegistrationProposal from './RegistrationProposal';
export default RegistrationProposal;
